// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fullscreen-element-portal {
  transition: top 200ms ease 0ms,
    right 200ms ease 0ms,
    bottom 200ms ease 0ms,
    left 200ms ease 0ms,
    padding 50ms linear 75ms;
  padding: 0;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/common/ui/fullscreen/FullscreenElementPortal.less"],"names":[],"mappings":"AACA;EACE;;;;4BAAA;EAOA,UAAA;AAFF","sourcesContent":["\n.fullscreen-element-portal {\n  transition:\n    top 200ms ease 0ms,\n    right 200ms ease 0ms,\n    bottom 200ms ease 0ms,\n    left 200ms ease 0ms,\n    padding 50ms linear 75ms;\n\n  padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
